import React, { useEffect, useState } from "react";
import ListLayout from "../../../components/common/List/List-Layout";
import { useGetAllUserMealQuery } from "../../../store/api/meals";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from '../../../components/common/List/DeletePopup'
import { useDeleteAllUserMealMutation } from "../../../store/api/meals";

function AssignedMealList() {
  const permissionname = 'meals'
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const navigate = useNavigate();
  const { data: tabledata, refetch,isLoading } = useGetAllUserMealQuery({
    page: currentPage,
    page_size: pageSize,
  });

  const [deleteMeal] = useDeleteAllUserMealMutation()
 
  const handleDelete = async () => {
    try {
      
      let reponse = await deleteMeal(deleteid.meal_id);
      setIsModalOpen(false);
      refetch();
    } catch (error) {
 
    }
  };

 useEffect(()=>{
  refetch();
 },[])

  const tableHeaders = [
    { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
    { label: "Member Name", key: "member_name" },
    { label: "Assigned_by", key: "assigned_by" },
  ];

  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      onClick: (row) =>
        navigate(`/asigned-meal-view`, { state: { data: row } }),
    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => {
        navigate("/asigned-meal-edit", { state: { data: row } });
      },
    },
    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);

      },
    },
  ];


  return (
    <>
      <ListLayout
        permissionname={permissionname}
        title="Meals"
        tableHeaders={tableHeaders}
        tabledata={tabledata} 
        currentPage={currentPage}
        actionButtons={actionButtons}
        totalrecords={tabledata?.total || 0}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={isLoading}
      />
         {isModalOpen && (
          <ConfirmationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={handleDelete}
          
          />
        )}
    </>
  );
}

export default AssignedMealList;
